import { Encounter, EncounterType, PrenatalExamData } from '@hb/shared'

export const isBpFlagged = (bp?: { systolic: number; diastolic: number }): boolean => {
  if (!bp) return false
  return bp.systolic >= 140 || bp.diastolic >= 90
}

export const isFhtFlagged = (bpm?: number): boolean => {
  if (bpm == null) return false
  return bpm < 110 || bpm > 160
}

export const isFundalHeightFlagged = (cm?: number, gestationalAgeDays?: number): boolean => {
  if (cm == null || gestationalAgeDays == null) return false
  if (gestationalAgeDays < 140) return false // only flag after 20w
  const gaWeeks = gestationalAgeDays / 7
  return Math.abs(cm - gaWeeks) > 2
}

export const isTempFlagged = (temp?: number): boolean => {
  if (temp == null) return false
  return temp > 100.4
}

export const isPulseFlagged = (pulse?: number): boolean => {
  if (pulse == null) return false
  return pulse < 60 || pulse > 100
}

export const formatGa = (days?: number): string => {
  if (days == null) return '—'
  return `${Math.floor(days / 7)}w ${days % 7}d`
}

export const formatBp = (bp?: { systolic: number; diastolic: number }): string => {
  if (!bp) return ''
  return `${bp.systolic}/${bp.diastolic}`
}

export const getEncounterPresentingComplaint = (encounter: Encounter): string | null => {
  if (encounter.type !== EncounterType.ANTEPARTUM) return null
  const data = encounter.data as PrenatalExamData
  const raw = data.soapNote?.subjective ?? data.reasonForVisit ?? null
  if (!raw) return null
  return raw.length > 30 ? `${raw.slice(0, 30)}…` : raw
}
